import HeroSection from './components/HeroSection';
import ManifestoSection from './components/ManifestoSection';
import CompetenceSection from './components/CompetenceSection';
import DomainSection from './components/DomainSection';
import VisionSection from './components/VisionSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <HeroSection />
      <ManifestoSection />
      <CompetenceSection />
      <DomainSection />
      <VisionSection />
      <FooterSection />
    </main>
  );
}